<template>
  <div class="back px-0 pb-0 pt-lg-5 pt-md-0">
    <SitecoreLink
      class="icon ma-0 pa-0"
      :iconField="this.fields.LinkIcon"
      :linkField="this.fields.Link"
    ></SitecoreLink>
  </div>
</template>

<script>
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
import SitecoreLink from '../Sitecore/SitecoreLink';

export default {
  name: 'BackToLink',
  data() {
    return {
    };
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    SitecoreLink
  },
  computed: {
    isExperienceEditor() {
      // Todo may need to add other check like preview mode in SC editor...
      return isExperienceEditorActive();
    },
  },
};
</script>
<style lang="scss" scoped>

.v-list-item--link:before {
  background: none !important;
}
.back {
  display:flex;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding-top: 4px !important;
  }

  &::v-deep {
    .theme--light.v-list-item.v-list-item--link{
      color: map-deep-get($colors, 'blue-title', 'base') !important;
      font-size: 16px;
      &:before{
        background-color: transparent !important;
      }
    }    
    .v-list-item__icon{
      margin: Auto 4px Auto 0px !important;
      min-width: 16px !important;
      .v-icon{
        line-height: 1;
        font-size: 16px;
        color: #000!important;
        caret-color: #000!important;
      }
    }
  }
  
}
.icon{
  &::v-deep {
    a{
        padding:0 !important;
        padding-bottom: 3px !important;
        min-height: 34px !important;
        text-decoration: none;
    }
  }
}
a {
  text-decoration: none;
}
</style>
